/*
 * Scroll-into-view reveals (original actions a-11..a-14).
 *
 * Four reusable variants, applied by class. Each element fades in once as it
 * enters the viewport, matching the original 1s ease reveal with a 0.1s delay.
 */
import type { gsap as GSAP } from 'gsap'

import { gsap, ScrollTrigger, EASE } from './core'

interface RevealVariant {
    selector: string
    from: gsap.TweenVars
}

const VARIANTS: RevealVariant[] = [
    { selector: '.fade-in-on-scroll', from: { opacity: 0 } },
    { selector: '.fade-in-move-on-scroll', from: { opacity: 0, y: 25 } },
    { selector: '.fade-in-slace-on-scroll', from: { opacity: 0, scale: 1.1 } },
    { selector: '.fade-in-blur-on-scroll', from: { opacity: 0, filter: 'blur(5px)' } }
]

const START = 'top 88%'

export const initScrollReveal = (ctx: GSAP.Context, scope: HTMLElement): void => {
    ctx.add(() => {
        VARIANTS.forEach(({ selector, from }) => {
            const els = gsap.utils.toArray<HTMLElement>(scope.querySelectorAll(selector))

            els.forEach((el) => {
                gsap.set(el, from)

                ScrollTrigger.create({
                    trigger: el,
                    start: START,
                    once: true,
                    onEnter: () => {
                        gsap.to(el, {
                            opacity: 1,
                            y: 0,
                            scale: 1,
                            filter: 'blur(0px)',
                            duration: 1,
                            delay: 0.1,
                            ease: EASE
                        })
                    }
                })
            })
        })
    })
}
